export default "__VITE_ASSET__C5cu6TQ9__"